import generatePicker from 'antd/es/date-picker/generatePicker';
import momentGenerateConfig from 'rc-picker/lib/generate/moment';

const MomentDatePicker = generatePicker(momentGenerateConfig);

const MomentTimePicker = MomentDatePicker.TimePicker;

const MomentRangePicker = MomentDatePicker.RangePicker;

export { MomentDatePicker, MomentRangePicker, MomentTimePicker };
